import { AgTechQueryParam, LabBookSampleTypes, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { ILabBookAllResponse } from "../models";
import { URLConfig } from "../network/urlStore";

export const getSoilSample = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ILabBookAllResponse> => {
  let url = URLConfig.getLabBookURL(LabBookSampleTypes.SOIL);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILabBookAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Soil Sample data", error);
      }
    );
  });
};

export const getSoilSampleNextPage = (
  nextPageURI: string
): Observable<ILabBookAllResponse> => {
  const url = URLConfig.getLabBookNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (soilSampleResponse) => {
        if (soilSampleResponse) {
          const soilSamplesResponse =
            soilSampleResponse as unknown as ILabBookAllResponse;

          subscriber.next(soilSamplesResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations field Journal data", error);
      }
    );
  });
};

export const addSoilSample = (
  requestPayload: any
): Observable<ILabBookAllResponse> => {
  const url = URLConfig.getLabBookURL(LabBookSampleTypes.SOIL);
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (res: unknown) => {
        const response = res as ILabBookAllResponse;
        subscriber.next(response);

        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while adding soil sample", error);
      }
    );
  });
};

export const getContentLengthForSoilSample = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam; 
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getLabBookURL(LabBookSampleTypes.SOIL);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const updateSoilSample = (
  requestPayload: any
): Observable<ILabBookAllResponse> => {
  const url = URLConfig.getLabBookURL(LabBookSampleTypes.SOIL);
  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (res: unknown) => {
        const response = res as ILabBookAllResponse;
        subscriber.next(response);

        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while adding variants in inventory", error);
      }
    );
  });
};
